<template>
  <div v-if="hasSelecteableEntityItems"
       class="question">
    <h2 class="whitespace-pre-line">{{ $t('Select entity item') }}</h2>

    <div
      v-if="needsEntityItemSelected"
      class="w-full form-select mb-3"
      :class="{'empty': !inspection.entity_item}"
      @click="showDropdown">
      <template v-if="inspection.entity_item">
        {{ inspection.entity_items[inspection.entity_item] }}
      </template>
      <template v-else>
        {{ $t('Select from dropdown') }}
      </template>

    </div>
    <template v-else-if="hasEntityItemAlreadySet">
      {{ $t(inspection.entity_items[inspection.entity_item]) }}
    </template>

    <portal to="modals">
      <transition name="fade">
        <DropdownModal
          v-if="dropdownVisible"
          :responses="entityItems"
          :response="inspection.entity_item ? [inspection.entity_item] : []"
          :multiple="false"
          :limit="limit"
          @save="entityItemSelected"
          @close="closeDropdown"
        />
      </transition>
    </portal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import _ from 'lodash';
  import DropdownModal from '@/_legacy/views/ConductInspection/Modals/DropdownModal.vue';
  import conductionEntityItemsMixin from '@/_legacy/mixins/conductionEntityItemsMixin';
  import { ENTITY_ITEMS_DROPDOWN_LIMIT } from '@/_legacy/constants';

  export default {
    components: { DropdownModal },
    mixins: [conductionEntityItemsMixin],
    data: () => ({
      needsEntityItemSelected: false,
      hasEntityItemAlreadySet: true,
      hasSelecteableEntityItems: false,
      dropdownVisible: false,
      limit: ENTITY_ITEMS_DROPDOWN_LIMIT,
    }),
    computed: {
      inspection() {
        return this.$store.getters['conduct/inspection'];
      },

      entityItems() {
        return _(this.inspection.entity_items).map(
          (value, key) => ({
            uuid: parseInt(key, 10),
            title: value,
          }),
        )
          .filter(({ uuid }) => this.inspectionEntityItems.includes(uuid))
          .sortBy('title')
          .value();
      },
    },
    created() {
      this.hasEntityItemAlreadySet = !!this.inspection.entity_item;
      this.hasSelecteableEntityItems = this.inspection.entity_items && this.inspectionEntityItems.length > 1;
      this.needsEntityItemSelected = this.hasSelecteableEntityItems;
    },
    methods: {
      ...mapActions({
        entityItemChanged: 'conduct/entityItemChanged',
      }),

      entityItemSelected([entityItemId]) {
        this.entityItemChanged({
          entityItemId,
        });
        this.dropdownVisible = false;
      },

      showDropdown() {
        this.dropdownVisible = true;
      },

      closeDropdown() {
        this.dropdownVisible = false;
      },
    },
  };
</script>
